export default __webpack_public_path__ + "static/media/screenshot6.e86aacf8.png";